// One place that turns any country/region CODE into its full name, used everywhere a jurisdiction is
// shown so users never see bare acronyms like "KE". ISO-3166 alpha-2 codes resolve via Intl.DisplayNames;
// a small override map covers the non-ISO groupings Kadana's taxonomy uses.
const OVERRIDES = {
  UK: "United Kingdom", EU: "European Union", EEA: "European Economic Area",
  GLOBAL: "Global", WORLD: "Global", ROW: "Rest of World",
  AFRICA: "Africa", PAN: "Pan-Africa", EA: "East Africa", WA: "West Africa",
  NORDICS: "Nordics", MENA: "Middle East & North Africa", APAC: "Asia-Pacific", LATAM: "Latin America",
};

let _dn = null;
try { _dn = new Intl.DisplayNames(["en-GB"], { type: "region" }); } catch { try { _dn = new Intl.DisplayNames(["en"], { type: "region" }); } catch { _dn = null; } }

export function countryName(code) {
  if (!code) return code;
  const c = String(code).trim();
  const up = c.toUpperCase();
  if (OVERRIDES[up]) return OVERRIDES[up];
  if (/^[A-Za-z]{2}$/.test(c) && _dn) {
    try { const n = _dn.of(up); if (n && n !== up) return n; } catch { /* fall through */ }
  }
  return c;
}

export function countryNames(list) {
  if (!Array.isArray(list)) return list ? countryName(list) : list;
  return list.map(countryName).join(", ");
}

// Patch 59 — single source of truth for jurisdiction/region ORDER, shared by the jurisdiction picker
// (Landing hero) and the Compare Markets tool so their country ordering can never drift apart again.
// Flattens the appendix-k region taxonomy into region-grouped optgroups, preserving taxonomy order.
export function flattenRegions(tax) {
  const groups = [];
  (tax || []).forEach((node) => {
    if (node.bloc) {
      groups.push({ label: node.name, options: (node.members || []).map((m) => ({ code: m.code, name: countryName(m.name || m.code), zero: m.connectors === 0 })) });
    } else if (node.major_countries) {
      groups.push({ label: "Major countries", options: node.major_countries.map((c) => ({ code: c.code, name: countryName(c.name || c.code) })) });
    } else if (node.region) {
      (node.subregions || []).forEach((sr) => groups.push({ label: `${node.name} — ${sr.name}`, options: (sr.members || []).map((code) => ({ code, name: countryName(code) })) }));
    } else if (node.global) {
      groups.push({ label: node.name, options: [{ code: node.global, name: node.name }] });
    }
  });
  return groups;
}

// Flat, de-duplicated ordered [{code,name}] derived from the SAME flattenRegions grouping above.
export function flattenRegionOptions(tax) {
  const flat = []; const seen = new Set();
  flattenRegions(tax).forEach((g) => g.options.forEach((o) => {
    if (!seen.has(o.code)) { seen.add(o.code); flat.push({ code: o.code, name: o.name }); }
  }));
  return flat;
}
